import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconHomeCircle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="home-circle"><path fillRule="evenodd" clipRule="evenodd" d="M10.1289 1.9619C11.2872 1.29501 12.7128 1.29501 13.8711 1.9619L19.1211 4.98462C20.2836 5.65391 21 6.89311 21 8.23446V17.25C21 19.3211 19.3211 21 17.25 21H6.75C4.67893 21 3 19.3211 3 17.25V8.23446C3 6.89311 3.71644 5.65391 4.87888 4.98462L10.1289 1.9619ZM8.75 12.25C8.75 10.4551 10.2051 9 12 9C13.7949 9 15.25 10.4551 15.25 12.25C15.25 14.0449 13.7949 15.5 12 15.5C10.2051 15.5 8.75 14.0449 8.75 12.25Z" fill="currentColor"/></CentralIconBase>;
};

export default IconHomeCircle;
